<template>
    <div>
        <!-- 第一屏 -->
        <List1></List1>
        <!-- 第二屏 -->
        <List2></List2>
        <!-- 第三屏 -->
        <List3></List3>
        <!-- 第四屏 -->
        <List4></List4>
        <!-- 第五屏 -->
        <List5></List5>
    </div>
</template>

<script>
import List1 from '@/components/service/list/List1.vue'
import List2 from '@/components/service/list/List2.vue'
import List3 from '@/components/service/list/List3.vue'
import List4 from '@/components/service/list/List4.vue'
import List5 from '@/components/service/list/List5.vue'

export default {
    name:'ServiceList',
        components: {
            List1,
            List2,
            List3,
            List4,
            List5,
    },
}
</script>